import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/usb': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M641.5 256C641.5 259.1 639.8 262.1 637 263.5L547.9 317C546.5 317.8 545.1 318.4 543.4 318.4 542 318.4 540.3 318.1 538.9 317.3 536.1 315.6 534.4 312.8 534.4 309.5V273.9H295.7C321 313.5 336.2 380.8 365.3 380.8H392V354C392 349 395.9 345.1 400.9 345.1H490C495 345.1 498.9 349 498.9 354V443.1C498.9 448.1 495 452 490 452H400.9C395.9 452 392 448.1 392 443.1V416.4H365.3C289.9 416.4 284.2 273.9 240.6 273.9H140.3C132.2 304.5 104.4 327.4 71.3 327.4 32 327.3 0 295.3 0 256S32 184.7 71.3 184.7C104.4 184.7 132.3 207.5 140.3 238.2 179.4 238.2 184.2 247.7 214.9 177.8 255 88.7 273 95.7 323.8 95.7 331.3 74.8 350.8 60.1 374.2 60.1 403.7 60.1 427.7 84 427.7 113.6S403.8 167.1 374.2 167.1C350.8 167.1 331.3 152.3 323.8 131.5H294C264.9 131.5 249.7 198.9 224.4 238.4H534.5V202.8C534.5 199.5 536.2 196.7 539 195 541.8 193.3 545.4 193.6 547.9 195.3L637 248.8C639.8 249.9 641.5 252.9 641.5 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/usb.js
// module id = cb6c
// module chunks = 144